export default __webpack_public_path__ + "static/media/Asset-20.953b1f99.png";